import { Component, Input } from '@angular/core';
import { ReportsService } from "../reports.service";
import { FileSaverService } from "../../shared/file-saver.servive";
import { ReportTypes } from '../reports.enum';
import { FileType } from '../../shared/filetype.enum';

@Component({
    moduleId: module.id,
    selector: 'unique-users-report',
    templateUrl: 'unique-users-report.component.html'
})

export class UniqueUsersReportComponent {
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() fileName: string;
    disableCsvButton: boolean = false;
    disableExcelButton: boolean = false;

    constructor(
        private reportsService: ReportsService,
        private fileSaverService: FileSaverService) { }

    downloadCsv(event: any) {
        event.preventDefault();
        this.disableCsvButton = true;
        let fileName = `${this.fileName} Unique Users Count`;
        let file = `${fileName}.csv`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.UniqueUsers, FileType.Csv).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableCsvButton = false; }
        );
    }

    downloadExcel(event: any) {
        event.preventDefault();
        this.disableExcelButton = true;
        let fileName = `${this.fileName} Unique Users Count`;
        let file = `${fileName}.xlsx`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.UniqueUsers, FileType.Excel).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableExcelButton = false; }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/reports/unique-users-report/unique-users-report.component.ts